/************************************************************************************************/
//
// ! Eigentliche Skripte
//


var rwd_menu = 0;
var cachedWidth = jQuery(window).width();
var scrollMem = 0;
var showPosts = 0;

function showMorePosts() {

    showPosts += 5;
    jQuery(".post.simple:lt("+showPosts+")").show();
    if(showPosts>=jQuery('.post.simple').length) {
        jQuery(".showMorePosts").hide();
    }
}

function resizetrigger() {

    if (jQuery("#rwd_menu_link").css("display") === "block") {
        if (rwd_menu === 0) {
            rwd_menu = $.jPanelMenu({ menu: '#mobile_menu', trigger: '#rwd_menu_link', direction: 'left' });
        }
        if (jQuery("#jPanelMenu-menu").length === 0) {
            rwd_menu.on();
        }
    } else {
        if (rwd_menu) {
            rwd_menu.off();
        }
    }

}

/************************************************************************************************/
//
// ! Scroll-Funktionen
//


function scrollToTop() {

    jQuery(window).scrollTop(jQuery(window).scrollTop() / 1.6);
    if (jQuery(window).scrollTop() > 5) {
        window.setTimeout(scrollToTop, 100);
    } else {
        jQuery(window).scrollTop(0);
    }
}

/************************************************************************************************/
//
// ! Ready
//

function scrollToHash(hash, newPage = false) {
    if (!hash) return;

    const target = $(hash);

    if (target.length) {
        const headerHeight = jQuery("header").height()*1.5;
        const targetPosition = target.offset().top - headerHeight;
        const maxScroll = jQuery(document).height() - jQuery(window).height();
        const finalPosition = Math.min(targetPosition, maxScroll);
        
        if(newPage) {
            window.scrollTo(0, 0);
            setTimeout(() => {
                 jQuery('html, body').animate({
                    scrollTop: finalPosition
                }, 1024);
            }, 500)
        } else {
            jQuery('html, body').animate({
                scrollTop: finalPosition
            }, 1024);
        }
      
    }
}

window.topSwiper = 0;
window.bottomswiper = 0;

jQuery(document).ready(function() {

    jQuery("table").wrap('<div class="table" />');

    resizetrigger();

    scrollToHash(window.location.hash, true);

    jQuery(document).on('click', 'a[href^="#"]', function (event) {
        const hash = this.hash;
        if (hash && $(hash).length) {
            event.preventDefault();
            scrollToHash(hash);
        }
    });

    jQuery(window).resize(function() {
        var newWidth = jQuery(window).width();
        if (newWidth !== cachedWidth) {
            resizetrigger();
            cachedWidth = jQuery(window).width();
        }
    });

    jQuery("#top a").click(function(e) {
        e.preventDefault();
        scrollToTop();
    });

    document.querySelectorAll('.wp-block-cpp-team').forEach(function(el) {
        id = el.id;
        window[id].top = new Swiper('#'+id+' .swiper-container.top',{
            slidesPerView: 3,
            loop: true,
            navigation: {
                prevEl: '#'+id+' .team-swipe-prev',
                nextEl: '#'+id+' .team-swipe-next',
            },
            breakpoints: {
                768: {
                    allowTouchMove: false,
                    slidesPerView: 4,
                }
            }
        });
    });

    document.querySelectorAll('.wp-block-cpp-team').forEach(function(el) {
        id = el.id;
        window[id].bottom = new Swiper('#'+id+' .swiper-container.bottom',{
            slidesPerView: 3,
            loop: true,
            initialSlide: 3,
            navigation: {
                prevEl: '#'+id+' .team-swipe-prev',
                nextEl: '#'+id+' .team-swipe-next',
            },
            breakpoints: {
                768: {
                    allowTouchMove: false,
                    slidesPerView: 4,
                    initialSlide: 4,
                }
            }
        });
    });

    logoSwiper = new Swiper('.wp-block-cpp-logo-slider .swiper-container',{
        slidesPerView: 'auto',
        loop: true,
        spaceBetween: 32,
        centeredSlides: true,
        freeMode: true,
        speed: 3000,
        resistance: false,
        loopAdditionalSlides: 10,
        loopedSlides: 10,
        autoplay: {
            delay: 1
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                spaceBetween: 52,
            }
        }
    });

    logoSwiper = new Swiper('.logos-slider .swiper-container',{
        slidesPerView: 'auto',
        loop: true,
        spaceBetween: 32,
        centeredSlides: true,
        freeMode: true,
        speed: 3000,
        resistance: false,
        loopAdditionalSlides: 10,
        loopedSlides: 10,
        autoplay: {
            delay: 1
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                spaceBetween: 52,
            }
        }
    });

    const wrappers = document.querySelectorAll('.logos-slider .swiper-container .swiper-wrapper, .wp-block-cpp-logo-slider .swiper-container .swiper-wrapper');

    if(wrappers) {
        wrappers.forEach((wrapper) => {
            const slides = wrapper.children;
            if(slides) {
                Array.from(slides).forEach(slide => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('swiper-slide-duplicate');
                    wrapper.appendChild(clone);
                });
            }
           
        })
    }
   

    logoSwiper = new Swiper('.wp-block-cpp-siegel-slider .swiper-container',{
        slidesPerView: 3,
        loop: true,
        spaceBetween: 32,
        centeredSlides: true,
        freeMode: true,
        speed: 3000,
        resistance: false,
        autoplay: {
            delay: 1
        },
        breakpoints: {
            768: {
                slidesPerView: 5,
            },
            1024: {
                slidesPerView: 6,
            },
            1280: {
                slidesPerView: 7,
            },
        }
    });

    quoteSwiper = new Swiper('.wp-block-cpp-testimonial-slider .swiper-container', {
        loop: true,
        centeredSlides: true,
        autoplay: {
            delay: 6000
        },
        navigation: {
            prevEl: '.testimonials-swipe-prev',
            nextEl: '.testimonials-swipe-next',
        }
    });

    /*******************************************/
    /*
    /*  Fancybox
    */

    jQuery('[href$=".jpg"]').fancybox({
        afterClose: function(i) {
        },
    });

    jQuery('[href$=".png"]').fancybox({
        afterClose: function(i) {
        }
    });

    jQuery('[href$=".mp4"]').fancybox({
        afterClose: function(i) {
        }
    });

    /*******************************************/
    /*
    /*  Header anpassen
    */

    headerH = jQuery("header").innerHeight();
    winH = jQuery(window).innerHeight();
    jQuery("#wrapall").css("margin-top",headerH+"px");
    jQuery("header").addClass("fixed");
    jQuery("nav.mobile").css("top",headerH+"px");

    jQuery(".icon.rwd").on("click",function() {
        headerH = jQuery("header").innerHeight();
        winH = jQuery(window).innerHeight();
        if(jQuery("nav.mobile").height()==0) {
            jQuery("body").addClass("noscroll");
            jQuery("nav.mobile").css("top",headerH+"px");
            jQuery("nav.mobile").addClass("show").animate({ height: winH-headerH });
            jQuery("nav.mobile").show();
            console.log(winH-headerH);
        } else {
            jQuery("nav.mobile").animate({ height: 0 },function(){
              jQuery("body").removeClass("noscroll");
              jQuery("nav.mobile").removeClass("show")
          });
        }
    });

    jQuery('.showMorePosts span').on('click',function() {
        showMorePosts();
    })

    showMorePosts();

    jQuery(".wp-block-cpp-accordion h2").click(function(e) {
    e.preventDefault();
    if (jQuery(this).hasClass("show")) {
        jQuery(".wp-block-cpp-accordion h2").removeClass("show");
        jQuery(".wp-block-cpp-accordion .innerContent").animate({ height: 0 });
        scrollMem = 0;
    } else {
        jQuery(".wp-block-cpp-accordion h2").removeClass("show");
        if (jQuery(this).next().height() <= 0) {
            jQuery(this).addClass("show");
            jQuery(".wp-block-cpp-accordion .innerContent").animate({ height: 0 });
            h = jQuery(this).next().find("div").height() + 1.55 * 16;
            jQuery(this).next().animate({ height: h }, 300, function() {
                if (!scrollMem) {
                    scrollMem = jQuery(window).scrollTop();
                    st = jQuery(this).prev().offset().top;
                    stO = jQuery("header").height();
                    jQuery('html,body').animate({ scrollTop: st - stO - 40 }, 'slow');
                }
            });
        } else {
            jQuery(".wp-block-cpp-accordion .innerContent").animate({ height: 0 });
        }
    }
    });

    var iconBoxAlternate = 0;
    jQuery(".wp-block-cpp-iconbox").each(function() {
        jQuery(this).addClass("alternate"+((iconBoxAlternate)%2));
        iconBoxAlternate++;
    });

    jQuery(window).scroll(function() {
        jQuery(".wp-block-cpp-iconbox").each(function() {
            wh = jQuery(window).innerHeight();
            st = jQuery(window).scrollTop();
            of = jQuery(this).offset().top-st;
             h = jQuery(this).height();
            if(of<wh/2 && of+h>wh/2) {
                jQuery(this).addClass("highlight");
            } else {
                jQuery(this).removeClass("highlight");
            }
        })
    })

        jQuery(".qa").on("click",function() {
        var thisCurrent = (jQuery(this).hasClass("show"));
        jQuery(".qa").removeClass("show");
        if(!thisCurrent) {
            jQuery(this).addClass("show");
        }
    })

    document.querySelectorAll('.wp-block-cpp-abbinder .details a').forEach(function(email) {
        var parts = email.innerHTML.split('@');
        if(parts.length>1) {
            email.innerHTML = parts[0] + '<wbr>@' + parts[1];
        }
    })

})
